import React, { useEffect, useRef, useState } from "react";
import { getBidderByUuid, updateBidderForEvent } from "services";
import { JBSecondaryBidderTable } from "./JbSecondaryBidderTable";
import JBCompletedStatusComponent from "./JBCompletedStatusComponent";
import {
  fetchPrimaryBidderESignDocument,
  notifyPrimaryBidderAboutAllConsentsReceived,
} from "services/bidder";
interface JBCompletedStepsComponentProps {
  bidderUuid: any;
  bidder: any;
  stepsTitles: any;
  activeStep: any;
  setActiveStep: any;
  init: any;
}
export type tableData = {
  [x: string]: any;
  id: string;
};
export default function JBCompletedStepsComponent({
  bidderUuid,
  bidder,
  stepsTitles,
  activeStep,
  setActiveStep,
  init,
}: JBCompletedStepsComponentProps) {
  const [secondaryBidderConsentDetails, setSecondaryBidderConsentDetails] =
    useState([]);

  const divRef = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>(0);
  const pollingCall = async (bidderUuid: string) => {
    console.log("pollingCall called");
    if (!bidderUuid) return;
    try {
      const currentBidderData: any = await getBidderByUuid(bidderUuid);
      if (!currentBidderData) return;
      if (currentBidderData.verification_step === "wait_for_consent") {
        const secondaryBidders = currentBidderData?.bidder_relations || [];
        const consentDataList =
          currentBidderData?.esigned_data?.consent_data || [];
        const consentMap =
          consentDataList.length > 0
            ? Object.fromEntries(
                consentDataList.map((c: any) => [
                  c.bidder_uuid,
                  c.consent_status,
                ])
              )
            : {};

        const updatedBidders = secondaryBidders.map((b: any) => {
          return {
            ...b,
            consent_status: consentMap[b.bidder_uuid] || "pending",
          };
        });
        const totalApproved = consentDataList.filter(
          (c: any) => c.consent_status === "approved"
        ).length;
        setSecondaryBidderConsentDetails(updatedBidders);

        //here update the data when all secondary bidders have approved
        console.log("secondaryBidders.length:", secondaryBidders.length);
        console.log("consentDataList.length:", consentDataList.length);
        if (secondaryBidders?.length === totalApproved) {
          //All Consents Received
          console.log("All Consents Received");
          try {
            if (!currentBidderData?.esigned_data?.all_consent_received) {
              await notifyPrimaryBidderAboutAllConsentsReceived({
                eligible_bidders_uuid: bidderUuid,
              });
            }
          } catch (error) {
            console.log("error: ", error);
          }

          //here we need to somehow generate the bidder sined form
          //primary-esign/download-and-save
          try {
            if (!currentBidderData?.esigned_data?.is_kyc_file_persisted) {
              const payload = {
                eligible_bidder_uuid: bidderUuid,
                e_sign_request_id: currentBidderData?.esigned_data?.request_id,
              };
              await fetchPrimaryBidderESignDocument(payload);
            }
          } catch (error) {
            console.log("error: ", error);
          }

          await updateBidderForEvent({
            uuid: bidderUuid,
            meta: {
              ...currentBidderData?.meta,
              steps_status: {
                ...currentBidderData?.meta?.steps_status,
                completed: "completed",
              },
            },
            esigned_data: {
              ...currentBidderData?.esigned_data,
              all_consent_received: true,
              document_saved: true,
            },
            verification_step: "completed",
            digio_request_status: "approved",
          });
          setActiveStep(activeStep + 1);
          await new Promise((resolve) => setTimeout(resolve, 1000));
          await init();
        }
      }
    } catch (err) {
      console.error("Error during pollingCall:", err);
    }
  };
  useEffect(() => {
    if (!bidderUuid) return;
    if (bidder?.verification_step !== "wait_for_consent") return;

    let intervalId: NodeJS.Timeout | null = null;
    let isFetching = false;

    const startPolling = async () => {
      if (isFetching) return; // skip if already running
      isFetching = true;
      try {
        await pollingCall(bidderUuid);
      } catch (error) {
        console.error("Polling error:", error);
      } finally {
        isFetching = false;
      }
    };

    // Run immediately once
    startPolling();

    // Then run every 30 seconds
    intervalId = setInterval(startPolling, 30000);
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [bidderUuid]);

  useEffect(() => {
    const updateWidth = () => {
      if (divRef.current) {
        setWidth(divRef.current.offsetWidth);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, [window.innerWidth, width]);

  return (
    <div>
      <div ref={divRef}>
        {bidder?.verification_step === "wait_for_consent" ? (
          <div className="py-4 bg-white border-gray-100">
            <h2 className="text-sm md:text-lg font-semibold text-gray-800 mb-1">
              Waiting for Other Bidders to Provide Consent
            </h2>

            <p className="text-sm text-gray-600 mb-4">
              You’ve successfully completed your part. Once all bidders provide
              their consent, the application will proceed automatically.
            </p>

            <div className="space-y-4">
              <h3 className="text-center text-xs md:text-base font-semibold text-gray-800 flex gap-2 items-center">
                Secondary Bidder Consent Status
              </h3>

              <div className="mx-auto" style={{ width: `${width - 10}px` }}>
                <JBSecondaryBidderTable
                  bidders={secondaryBidderConsentDetails}
                />
              </div>
            </div>
          </div>
        ) : (
          <div>
            <JBCompletedStatusComponent bidderUuid={bidderUuid} />
          </div>
        )}
      </div>
    </div>
  );
}
